import React, { useEffect, useState } from "react";
import { getContact } from "./Contact.service";
import { decrypt } from "../../utilities/Encriptacion";
import './Contact.style.scss';

interface IContact {
    TIPO: string;
    PUESTO: string;
    NOMBRE: string;
    CORREO: string;
    TELEFONO: string;
}

const Contact: React.FC = () => {
    const [internalContacts, setInternalContacts] = useState<IContact[]>([]);

    useEffect(() => {
        const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
        const data = decrypt(sessionStorage.getItem('dataClient'), CLAVE);
        const id = JSON.parse(data).id;

        getContact(id, (contacts: IContact[]) => {
            setInternalContacts(contacts.filter(contact => contact.TIPO === 'INTERNO'));
        });
    }, []);

    const renderContactCard = (contact: IContact, index: number) => (
        <div key={index} className="contact-card">
            <h3>{contact.NOMBRE}</h3>
            <p><strong>Puesto:</strong> {contact.PUESTO}</p>
            <p><strong>Correo:</strong> <a href={`mailto:${contact.CORREO}`}>{contact.CORREO}</a></p>
            <p><strong>Teléfono:</strong> <a href={`tel:${contact.TELEFONO}`}>{contact.TELEFONO}</a></p>
        </div>
    );

    return (
        <div className="contact-container">
            <div className="contact-section">
                <h2>Contactos Internos</h2>
                <div className="contact-grid">
                    {internalContacts.length > 0 ? internalContacts.map(renderContactCard) : <p>No hay contactos internos disponibles.</p>}
                </div>
            </div>
        </div>
    );
}

export default Contact;
